import { makeRequest } from 'utils/requestLogger';

export default (id) => makeRequest('get', `/api/submissions/${id}/summary`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/grades/studentSummary.js